import type { FieldConfig } from './fieldTypes';

// This is a stub config, just to test fields display
export const fieldConfigs: FieldConfig[] = [
  {
    name: 'field.deviceName.name',
    type: 'text',
    register: 'DEVICE_NAME',
    defaultValue: 'USB Device 1',
    placeholder: 'field.deviceName.placeholder',
    help: 'field.deviceName.help',
  },
  {
    name: 'field.baudRate.name',
    type: 'select',
    register: 'BAUD_RATE',
    options: [
      { label: 'field.baudRate.option.9600', value: 9600 },
      { label: 'field.baudRate.option.19200', value: 19200 },
      { label: 'field.baudRate.option.38400', value: 38400 },
      { label: 'field.baudRate.option.57600', value: 57600 },
      { label: 'field.baudRate.option.115200', value: 115200 },
    ],
    defaultValue: 38400,
    help: 'field.baudRate.help',
  },
  {
    name: 'field.timeout.name',
    type: 'number',
    register: 'TIMEOUT',
    min: 1000,
    max: 30000,
    step: 500,
    defaultValue: 5000,
    help: 'field.timeout.help',
  },
  {
    name: 'field.autoReconnect.name',
    type: 'checkbox',
    register: 'AUTO_RECONNECT',
    defaultValue: true,
    help: 'field.autoReconnect.help',
  },
  {
    name: 'field.retryCount.name',
    type: 'number',
    register: 'RETRY_COUNT',
    min: 0,
    max: 10,
    step: 1,
    defaultValue: 3,
    help: 'field.retryCount.help',
  },
  {
    name: 'field.logLevel.name',
    type: 'select',
    register: 'LOG_LEVEL',
    options: [
      { label: 'field.logLevel.option.debug', value: 'debug' },
      { label: 'field.logLevel.option.info', value: 'info' },
      { label: 'field.logLevel.option.warning', value: 'warning' },
      { label: 'field.logLevel.option.error', value: 'error' },
    ],
    defaultValue: 'info',
    help: 'field.logLevel.help',
  },
];
